import { twMerge } from "tailwind-merge";
import { ITooltip, Tooltip } from "react-tooltip";

export interface ITooltipProps extends ITooltip {}

export default function ReactTooltip({ className, ...rest }: ITooltipProps) {
  return <Tooltip {...rest} className={twMerge(className)} />;
}
